var map = {
	"./ar/translation.json": [
		1009,
		9
	],
	"./en/translation.json": [
		2447,
		447
	],
	"./es/translation.json": [
		2615,
		615
	],
	"./fil/translation.json": [
		1519,
		519
	],
	"./fr/translation.json": [
		2702,
		702
	],
	"./ja/translation.json": [
		3388,
		388
	],
	"./ko/translation.json": [
		8637,
		637
	],
	"./ru/translation.json": [
		9140,
		140
	],
	"./vi/translation.json": [
		123,
		123
	],
	"./zh/translation.json": [
		8330,
		330
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8140;
module.exports = webpackAsyncContext;